const PlusIcon = ({ width = 16, height = 16, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    id='plus'
    data-name='Flat Line'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      id='primary'
      d='M5,12H19M12,5V19'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
      stroke='currentColor'
    />
  </svg>
);
export default PlusIcon;
